export const SERVER_URL = "https://placement-cell-db-server.herokuapp.com";
// export const SERVER_URL = "http://localhost:5000";
